import { render } from "./TheResetPasswordPage.vue?vue&type=template&id=b93c8756&scoped=true"
import script from "./TheResetPasswordPage.vue?vue&type=script&lang=js"
export * from "./TheResetPasswordPage.vue?vue&type=script&lang=js"

import "./TheResetPasswordPage.vue?vue&type=style&index=0&id=b93c8756&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b93c8756"]])

export default __exports__